<template>
  <div class="fs-movement">
    <ul>
      <div>
        <b-icon :icon="icon[0]" :variant="icon[1]" scale="1.2"></b-icon>
      </div>

      <div>
        <li>{{movement.description}}</li>
        <li class="date">
          <span>{{movementDate}}</span>
          <b-badge :variant="icon[1]">{{movement.status.name}}</b-badge>
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
import moment from "moment";

const icons = {
  1: ['upc-scan', 'info'], // Transfer
  2: ['screwdriver', 'primary'], // Teknik Serviste
  3: ['truck', 'success'], // Kargolandı
  4: ['clock', 'warning'], // Kayıt Oluşturuldu
  5: ['check-all', 'success'] // Kapatıldı
}

export default {
  props: {
    movement: Object
  },
  computed: {
    movementDate(){
      return moment(String(this.movement.created_at)).format('DD.MM.YYYY HH:mm') 
    },
    icon() {
      return icons[this.movement.status.id]
    }
  }
}
</script>

<style scoped>
  @import '../styles/fsMovement.min.css'
</style>


// WEBPACK FOOTER //
// src/pages/ERP/Stock/components/MovementCard.vue